export default {
    namespaced: true,

    state: {
        searchParams: {
            searchHasBeenExecuted: false,
            patientText: null, // searchbar
            chosenFacilityId: "", // dashboard
            chosenPractitionerId: "", // dashboard
            chosenStatus: "", // dashboard
        },

        dashboardRefresh: false,
        selectAPatientText: null, // select a patient searchbar
        
        advancedSearchParams: {
            searchHasBeenExecuted: false,
            patientText: null,
            dayOfBirth: null,
            monthOfBirth: null,
            yearOfBirth: null,
            facilityId: '',
            practitionerId: '',
            patientAddressText: null,
            patientId: null,
            issueDateFrom: null,
            issueDateTo: null,
            returnDateFrom: null,
            returnDateTo: null,
            dueDateFrom: null,
            dueDateTo: null,
            issueMethod: "",
            issueReason: "",
            thresholdMin: null,
            thresholdMax: null,
            testStatus: "",
            pageSize: process.env.VUE_APP_PAGINATION_PAGE_SIZE
        },
        results: {
            results: []
        },
    },

    getters: {
        GetResults(state) {
            return state.results
        },

        GetSelectAPatientText(state) {
            return state.selectAPatientText
        }, 

        GetSearchParams(state) {
            return state.searchParams
        },

        GetAdvancedSearchParams(state) {
            return state.advancedSearchParams
        },

        GetHasSearchBeenExecuted(state) {
            return state.searchHasBeenExecuted
        },

        GetDashboardRefresh(state) {
            return state.dashboardRefresh
        },

        GetPatientText(state) {
            return state.searchParams.patientText
        }
    },

    mutations: {
        SET_SEARCHBAR_DATA(state, data) {
            state.patientText = data.patientText
            state.results = data.results
            state.searchHasBeenExecuted = true
        },

        SET_SELECT_A_PATIENT_SEARCHBAR_DATA(state, data) {
            state.selectAPatientText = data.patientText
        },

        CLEAR_ISSUE_DATES(state) {
            state.advancedSearchParams.issueDateFrom = null
            state.advancedSearchParams.issueDateTo = null
        },

        CLEAR_RETURN_DATES(state) {
            state.advancedSearchParams.returnDateFrom = null
            state.advancedSearchParams.returnDateTo = null
        },

        CLEAR_DUE_DATES(state) {
            state.advancedSearchParams.dueDateFrom = null
            state.advancedSearchParams.dueDateTo = null
        },

        CLEAR_THRESHOLDS(state) {
            state.advancedSearchParams.thresholdMin = null
            state.advancedSearchParams.thresholdMax = null
        },

        CLEAR_SEARCH_STORE(state) {
            state.searchParams = {
                searchHasBeenExecuted: false,
                patientText: null, // searchbar
                chosenFacilityId: "", // dashboard
                chosenPractitionerId: "", // dashboard
                chosenStatus: "", // dashboard
            },
    
            state.dashboardRefresh = false,
            state.selectAPatientText = null, // select a patient searchbar
            
            state.advancedSearchParams = {
                advancedSearchHasBeenExecuted: false,
                patientText: null,
                dayOfBirth: null,
                monthOfBirth: null,
                yearOfBirth: null,
                patientDOB: null,
                facilityId: '',
                practitionerId: '',
                patientAddressText: null,
                patientId: null,
                issueDateFrom: null,
                issueDateTo: null,
                returnDateFrom: null,
                returnDateTo: null,
                dueDateFrom: null,
                dueDateTo: null,
                issueMethod: "",
                issueReason: "",
                thresholdMin: null,
                thresholdMax: null,
                testStatus: "",
                pageSize: process.env.VUE_APP_PAGINATION_PAGE_SIZE
            }

            state.results = {
                results: []
            }

        },

        PUSH_SEARCH_RESULTS(state, data) {
            state.results = data
            state.searchHasBeenExecuted = true
        },

        SET_HAS_SEARCH_BEEN_EXECUTED(state, data) {
            state.searchHasBeenExecuted = data
        },

        SET_DASHBOARD_REFRESH(state, data) {
            state.dashboardRefresh = data
        }
    },
    
    actions: {
        SetSearchbarData({commit}, data) {
            commit('SET_SEARCHBAR_DATA', data)
        },

        SetSearchResults({commit}, data) {
            commit('PUSH_SEARCH_RESULTS', data)
        },

        SetDashboardRefresh({commit}, data) {
            commit('SET_DASHBOARD_REFRESH', data)
        },

        SetSelectAPatientSearchbarData({commit}, data) {
            commit('SET_SELECT_A_PATIENT_SEARCHBAR_DATA', data)
        }, 

        SetMonthOfBirth({commit}, data) {
            commit('SET_MONTH_OF_BIRTH', data)
        },

        ClearIssueDates({commit}    ) {
            commit('CLEAR_ISSUE_DATES')
        },

        ClearReturnDates({commit}) {
            commit('CLEAR_RETURN_DATES')
        },

        ClearDueDates({commit}) {
            commit('CLEAR_DUE_DATES')
        },

        ClearThresholds({commit}) {
            commit('CLEAR_THRESHOLDS')
        },

        ClearSearchStore({commit}) {
            commit('CLEAR_SEARCH_STORE')
        }
    }
}